/* PLAY NATION EXCLUSIVES V6.0 — CINEMATIC COMMERCE
   Native scroll direction layer. No external dependencies. */
(() => {
  const clamp = (n, min = 0, max = 1) => Math.min(max, Math.max(min, n));
  const q = (s, r = document) => r.querySelector(s);
  const qa = (s, r = document) => [...r.querySelectorAll(s)];
  const desktop = () => matchMedia('(min-width: 990px)').matches;
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

  let raf = 0;
  const roots = {};

  const cache = () => {
    roots.hero = q('.template-index .pne-campaign-hero');
    roots.featured = q('.template-index .pne-featured-showroom');
    roots.hot = q('.template-index .pne-arrivals-marquee');
    roots.curated = q('.template-index .pne-featured-vault');
    roots.shelf = q('.template-index .pne-collector-shelf');
  };

  const sectionProgress = (el, startVh = .88, endVh = .12) => {
    if (!el) return 0;
    const r = el.getBoundingClientRect();
    const start = innerHeight * startVh;
    const end = innerHeight * endVh;
    return clamp((start - r.top) / Math.max(1, r.height + start - end));
  };

  const updateHero = () => {
    const el = roots.hero; if (!el) return;
    const r = el.getBoundingClientRect();
    const p = clamp((-r.top) / Math.max(1, r.height * .72));
    el.style.setProperty('--pne-v6-hero-scale', (1 + p * .075).toFixed(4));
    el.style.setProperty('--pne-v6-hero-media-y', `${(-p * 18).toFixed(1)}px`);
    el.style.setProperty('--pne-v6-hero-copy-x', `${(-p * 30).toFixed(1)}px`);
    el.style.setProperty('--pne-v6-hero-copy-y', `${(-p * 12).toFixed(1)}px`);
    el.style.setProperty('--pne-v6-hero-copy-opacity', (1 - p * .42).toFixed(3));
    el.style.setProperty('--pne-v6-access-y', `${(p * -24).toFixed(1)}px`);
    el.style.setProperty('--pne-v6-access-opacity', (1 - p * .12).toFixed(3));
    el.style.setProperty('--pne-v6-hero-shade', (1 - p * .08).toFixed(3));
  };

  const updateFeatured = () => {
    const el = roots.featured; if (!el) return;
    const p = sectionProgress(el, .90, .08);
    el.style.setProperty('--pne-v6-featured-media-y', `${((.5 - p) * 24).toFixed(1)}px`);
    el.style.setProperty('--pne-v6-featured-media-scale', (1.025 - p * .025).toFixed(4));
    el.style.setProperty('--pne-v6-featured-copy-y', `${((.5 - p) * 34).toFixed(1)}px`);
    el.style.setProperty('--pne-v6-featured-copy-opacity', (0.72 + Math.min(1, p * 2) * .28).toFixed(3));
  };

  const updateHot = () => {
    const el = roots.hot; if (!el) return;
    const viewport = q('.pne-arrivals-marquee__viewport', el);
    const track = q('.pne-arrivals-marquee__track', el);
    const firstGroup = q('.pne-arrivals-marquee__group', el);
    if (!viewport || !track || !firstGroup) return;
    const p = sectionProgress(el, .92, .10);
    const groupWidth = firstGroup.getBoundingClientRect().width;
    const maxShift = Math.max(0, groupWidth - viewport.clientWidth * .38);
    const x = -maxShift * p;
    track.style.setProperty('--pne-v6-hot-x', `${x.toFixed(1)}px`);
    el.style.setProperty('--pne-v6-hot-card-y', `${Math.sin(p * Math.PI) * -7}px`);
  };

  const updateShelf = () => {
    const el = roots.shelf; if (!el) return;
    const rail = q('.pne-shelf__rail', el); if (!rail) return;
    const p = sectionProgress(el, .90, .18);
    const max = Math.min(120, Math.max(0, rail.scrollWidth - rail.clientWidth) * .08);
    rail.style.setProperty('--pne-v6-shelf-x', `${(-max * p).toFixed(1)}px`);
  };

  const update = () => {
    raf = 0;
    if (!desktop() || reduced()) return;
    updateHero();
    updateFeatured();
    updateHot();
    updateShelf();
  };
  const schedule = () => { if (!raf) raf = requestAnimationFrame(update); };

  const initCurated = () => {
    const root = roots.curated; if (!root) return;
    const cards = qa('.pne-product-card', root);
    if (!cards.length) return;
    if (reduced() || !('IntersectionObserver' in window)) {
      cards.forEach(c => c.classList.add('is-v6-inview'));
      return;
    }
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const card = entry.target;
        const i = Number(card.style.getPropertyValue('--pne-card-i') || 0);
        setTimeout(() => card.classList.add('is-v6-inview'), Math.min(i * 95, 380));
        io.unobserve(card);
      });
    }, { threshold: .18, rootMargin: '0px 0px -8% 0px' });
    cards.forEach(c => io.observe(c));
  };

  const boot = () => {
    cache();
    document.documentElement.classList.add('pne-v6');
    initCurated();
    update();
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', () => { cache(); schedule(); }, { passive: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('shopify:section:load', () => {
    cache(); initCurated(); schedule();
  });
})();
